import styled from "styled-components"
import { mobile, mobilePortrait, tablet } from "../../Responsive"

export const Container = styled.div`
   background-color: ${({ theme }) => theme.body};
`

export const Wrapper = styled.div`
   margin-top: 100px;
   padding: 20px;
   min-height: 85vh;
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: space-between;

   ${tablet({ marginTop: "80px" })}
   ${mobile({ marginTop: "60px", padding: "10px" })}
    ${mobilePortrait({ marginTop: "40px" })}
`

export const Title = styled.h1``

export const Text = styled.p`
   margin-top: 20px;
`

export const RegionNote = styled.div`
   display: flex;
   align-items: center;
   justify-content: space-between;
   flex-direction: column;
   gap: 20px;

   ${tablet({ gap: "10px" })}
   ${mobile({ padding: "10px" })}
`

export const RegionText = styled.p`
   margin: 0px 50px;
   padding: 20px;
`

export const RegionLogo = styled.img`
   display: block;
   margin: 1rem auto;
   max-width: 150px;
   height: auto;
   object-fit: contain;
`
